import { QuestionMarkCircleIcon } from "@heroicons/react/24/outline";
import { lazy } from "react";

import type { FeatureMetadata } from "../../feature.types";

export const ClassStudentMapFeature: FeatureMetadata = {
  id: "classstudentmap",
  moduleName: "academics",
  navigation: {
    label: "Classstudentmap",
    path: "/classstudentmap",
    icon: QuestionMarkCircleIcon,
    order: 99,
  },
  route: {
    path: "/classstudentmap",
    element: lazy(() => import("./pages/Classstudentmap")),
  },
  permissions: {
    view: "Academics.Classstudentmap.view",
    create: "Academics.Classstudentmap.create",
    edit: "Academics.Classstudentmap.edit",
    delete: "Academics.Classstudentmap.delete",
  },
  readiness: "draft",
};
